import React from "react";
import "./MySliderToggle.css";

type ToggleValue = "dorëzuar" | "kthyer";

interface MySliderToggleProps {
	value: ToggleValue;
	onChange: (value: ToggleValue) => void;
	deliveredString: string;
	returnedString: string;
}

const MySliderToggle: React.FC<MySliderToggleProps> = ({
	value,
	onChange,
	deliveredString,
	returnedString,
}) => {
	const handleToggle = (val: ToggleValue) => {
		onChange(val);
	};

	return (
		<div className="sliderToggleContainer">
			<div
				className={`sliderToggleSlider ${
					value === "kthyer" ? "slideRight" : ""
				}`}
			/>

			<div
				className={`sliderToggleOption ${
					value === "dorëzuar" ? "active" : ""
				}`}
				onClick={() => handleToggle("dorëzuar")}
			>
				{deliveredString}
			</div>

			<div
				className={`sliderToggleOption ${
					value === "kthyer" ? "active" : ""
				}`}
				onClick={() => handleToggle("kthyer")}
			>
				{returnedString}
			</div>
		</div>
	);
};

export default MySliderToggle;
